import _ from 'lodash'
import StringMask from 'string-mask'
import { EventBus } from '@/event-bus'

const Mixins = {
  install: function (Vue) {
    Vue.mixin({
      computed: {
        classObj () {
          const { id, component, resultForm } = this
          let classe = {
            'd-none': this.validHideOn(id, component, resultForm)
          }
          classe[(this.print && 'xs12') || this.component.style || 'sx12 md6'] = true

          return classe
        }
      },

      methods: {
        validHideOn (id, component, resultForm) {
          if (component.hidden) return true
          if (!component.hideOn) return false
          // verifica o item da tab
          let m = id.match(/_(\d)/)
          const tabItem = m ? m[1] : 1
          let result = false
          component.hideOn.forEach(item => {
            const refKey = item.key.replace('$', `_${tabItem}`)
            if (['', null, undefined].indexOf(resultForm[refKey]) > -1 && item.value === '') result = true
            if (resultForm[refKey] === item.value) result = true
          })

          return result
        },
        onChange (val) {
          this.$emit('input', val)
          if (this.id) {
            const hasDataKey = this.id.split('.', 1)[0] + '.hasData'
            if (hasDataKey && hasDataKey.hasData && !this.resultForm[hasDataKey]) {
              console.log('aquii')
              this.resultForm[hasDataKey] = true
            }
          }
          if (this.component.events) {
            if (this.value === this.data) return
            this.component.events.forEach(event => {
              EventBus.$emit('eventField', {event, val})
            })
          }
        },
        f (val, filter, args) {
          let valReturn
          if (this.$options.filters[filter]) {
            if (args) valReturn = this.$options.filters[filter](val, ...args)
            else valReturn = this.$options.filters[filter](val)
          } else valReturn = val

          return valReturn
        },
        t (str, fallbackStr) {
          // use `$te` and `$t
          if (str) str = str.replace(/_(\d+)/g, '$')
          return this.$t && this.$te
            ? this.$te(str)
              ? this.$t(str)
              : fallbackStr
            : fallbackStr || str
        },
        m (val, mask) {
          if (!val || !mask) return val
          return new StringMask(mask).apply(val)
        },
        getVal (val, prop) {
          return _.get(val, prop)
        },
        groupBy (items, keys) {
          if (!items) return []
          let result = {}
          for (let k in items) {
            let x = items[k]
            let key = ''
            let headers = {}
            for (let i = 0; i < keys.length; i++) {
              key += x[keys[i]]
              headers[keys[i]] = x[keys[i]]
            }
            if (!result.hasOwnProperty(key)) result[key] = { key: key, headers: headers, items: [] }
            result[key].items.push(x)
          }
          return Object.values(result)
        },
        alertConfirmRemove (callback) {
          return this.$swal({
            text: 'Tem certeza que deseja remover?',
            type: 'warning',
            showCancelButton: true,
            focusConfirm: false,
            cancelButtonText: 'CANCELAR',
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.value) {
              return callback()
            }
            return false
          }).catch(err => {
            console.log(err)
            this.$swal(
              'Ops!',
              'Ocorreu um erro. Contate o administrador do sistema.',
              'error'
            )
          })
        }
      }
    })
  }
}

export default Mixins



// WEBPACK FOOTER //
// ./src/utils/mixins.js